import { request } from '@koi-design/vix-tools';
import { packApi } from '@/libs/tools';
// auth tree
export function getHomelandListApi() {
  return request({
    url: '/api/api-user/homeland/homelands/get_homeland_list/',
    method: 'get'
  });
}

export function getHomeLandRobotsApi(data) {
  return request({
    url: '/api/api-user/homeland/homelands/get_homeland_robots/',
    method: 'get',
    data
  });
}

export function getHomeLandAllRobotsApi(data) {
  return request({
    url: '/api/api-user/homeland/homelands/get_all_robots_from_homeland/',
    method: 'get',
    data
  });
}

export function getMembersApi(data) {
  return request({
    url: '/api/api-user/homeland/homelands/get_homeland_members/',
    method: 'get',
    data
  });
}

export function getMemberByRootApi(data) {
  return request({
    url: '/api/api-user/homeland/homelands/get_members_by_robot/',
    method: 'get',
    data
  });
}

export function deleteMembers(data) {
  return packApi({
    url: '/api/api-user/homeland/homelands/remove_homeland_member/',
    method: 'post',
    data
  });
}

export function updateRoleInfo(data) {
  return packApi({
    url: '/api/api-user/homeland/homelands/update_user_role_info/',
    method: 'post',
    data
  });
}

export function inviteHomeMemberApi(data) {
  return request({
    url: '/api/api-user/homeland/homelands/generate_invite_link/',
    method: 'post',
    data
  });
}

export function joinMemberApi(data) {
  return request({
    url: '/api/api-user/homeland/homelands/join_homeland_member/',
    method: 'get',
    data
  });
}

export function getHomeLandBotsApi(data) {
  return request({
    url: '/api/api-user/homeland/homelands/get_homeland_robots/',
    method: 'get',
    data
  });
}

export function removeMemberApi(data) {
  return packApi({
    url: '/api/api-user/homeland/homelands/remove_robot_member/',
    method: 'post',
    data
  });
}

export function unbindBotApi(data) {
  return packApi({
    url: '/api/api-user/homeland/homelands/unbind_from_robot/',
    method: 'get',
    data
  });
}

export function getInvitorInfo(data) {
  return request({
    url: '/api/api-user/homeland/homelands/get_invitor_info/',
    method: 'get',
    data,
    catchAll: true
  });
}

export const getUserRoleInfoApi = data => {
  return request({
    url: `/api/api-user/homeland/homelands/get_user_role_info/`,
    method: 'get',
    data
  });
};

export const getUserRoleInfoOutApi = data => {
  return request({
    url: `/api/api-user/homeland/homelands/get_user_role_info_out`,
    method: 'get',
    data
  });
};

export const inviteBotMemberApi = data => {
  return request({
    url: `/api/api-user/homeland/homelands/generate_invite_link_for_robot/`,
    method: 'get',
    data
  });
};

export function getRobotPermission(params) {
  return request({
    url: '/api/api-robot/robot/permission/get_permission/',
    method: 'get',
    params
  });
}

export function setRobotPermission(data) {
  return request({
    url: '/api/api-robot/robot/permission/set_permission/',
    method: 'post',
    data
  });
}

export const createHomelandApi = data => {
  return request({
    url: `/api/api-user/homeland/homelands/create_homeland/`,
    method: 'post',
    data
  });
};

export const modifyCommonHomelandApi = data => {
  return request({
    url: `/api/api-user/homeland/homelands/modify_common_homeland/`,
    method: 'post',
    data
  });
};

export const deleteHomelandApi = data => {
  return packApi({
    url: `/api/api-user/homeland/homelands/delete_homeland/`,
    method: 'post',
    data
  });
};

export const getOwnerHomelandApi = data => {
  return request({
    url: `/api/api-user/homeland/homelands/get_owner_homeland/`,
    method: 'get',
    data
  });
};

export const getHomelandInfoApi = data => {
  return request({
    url: `/api/api-user/homeland/homelands/get_homeland_info/`,
    method: 'get',
    data
  });
};

export const getRobotResourceApi = params => {
  return request({
    url: '/api/api-robot/robot/operation/robot_resource/',
    method: 'get',
    params
  });
};

export const migrateRobotApi = data => {
  return request({
    url: '/api/api-robot/robot/operation/migrate_robot/',
    method: 'post',
    data
  });
};

export const getHomelandPermissionApi = data => {
  return request({
    url: '/api/api-user/user/resource_permission/get_homeland_permission/',
    method: 'get',
    data
  });
};

export const setHomelandPermissionApi = data => {
  return packApi({
    url: '/api/api-user/user/resource_permission/set_homeland_permission/',
    method: 'post',
    data
  });
};

export const getHomelandUserPermissionApi = data => {
  return request({
    url: '/api/api-user/user/resource_permission/get_homeland_user_permission/',
    method: 'get',
    data
  });
};

export const levelHomelandApi = data => {
  return request({
    url: '/api/api-user/homeland/homelands/level_homeland/',
    method: 'put',
    data
  });
};

export const getHomelandMembersOptionsApi = data => {
  return request({
    url: '/api/api-user/homeland/homelands/get_homeland_members_options/',
    method: 'get',
    data
  });
};

export const transferHomelandApi = data => {
  return packApi({
    url: '/api/api-user/homeland/homelands/transfer_homeland/',
    method: 'post',
    data
  });
};

export const getHomelandResourceListApi = data => {
  return request({
    url: '/api/api-user/homeland/resource/resource_list/',
    method: 'get',
    data
  });
};

export const getHomelandResourceParticularApi = data => {
  return request({
    url: '/api/api-user/homeland/resource/particular/',
    method: 'get',
    data
  });
};
